module.exports = __webpack_public_path__ + "static/assets/12a848df1344950bae83d57f07c93440.svg";